import {CommunicationWebsocketMessage, WebsocketForceLogoutMessage} from "../proto/generated/api_entities_pb";
import {Logger} from "../utils/logger/Logger";
import {store} from "../store/store";
import {logout} from "../store/reducers/authReducer/authReducer";

const FORCE_LOGOUT_FLAG_KEY = 'showForceLogoutModal';

export const handleForceLogout = (coreMessage: CommunicationWebsocketMessage) => {
  try {
    const data = coreMessage.getData_asU8();
    const forceLogoutMsg = WebsocketForceLogoutMessage.deserializeBinary(data);
    
    const reason = forceLogoutMsg.getReason();
    const timestamp = forceLogoutMsg.getTimestamp();
    
    Logger.error(`Force logout: ${reason} at timestamp: ${timestamp}`);
    
    // Set flag to show modal on login page
    sessionStorage.setItem(FORCE_LOGOUT_FLAG_KEY, 'true');
    
    // Perform logout immediately (will redirect to login page)
    performLogout();
    
  } catch (e) {
    Logger.error("handleForceLogout error: " + e);
    // If error occurs, still perform logout
    performLogout();
  }
};

const performLogout = () => {
  // Clear Redux store and tokens
  store.dispatch(logout());
};

export const shouldShowForceLogoutModal = (): boolean => {
  const flag = sessionStorage.getItem(FORCE_LOGOUT_FLAG_KEY);
  if (flag === 'true') {
    sessionStorage.removeItem(FORCE_LOGOUT_FLAG_KEY);
    return true;
  }
  return false;
};
